import { Factory } from 'fishery'
import { v4 as uuidV4 } from 'uuid'
import { type OpalApiComponent } from '@opallabs/api'
import { safeDate } from '@opallabs/testing/src/dates'

type MomentScheduleResourceV3 = OpalApiComponent<'V3', 'moment_schedule'>

export const momentScheduleResourceFactory: Factory<MomentScheduleResourceV3> =
  Factory.define<MomentScheduleResourceV3>(() => ({
    id: uuidV4(),
    type: 'moment_schedule',
    attributes: {
      created_at: safeDate.toISOString(),
      day_segment: null,
      end_at: null,
      should_end_at_cascade: false,
      start_at: safeDate.toISOString(),
      updated_at: safeDate.toISOString(),
    },
    relationships: {
      moment: { data: { id: uuidV4(), type: 'moment' } },
    },
  }))
